import styled from 'styled-components';
import { FADE, t } from 'theme';

const Panel = styled.div`
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 9999;
  min-width: 230px;
  padding: 6px 8px;
  border: 1px solid ${t('rule')};
  background: ${t('panel')};
  color: ${t('fg')};
  transition: background-color ${FADE}, color ${FADE}, border-color ${FADE};
  opacity: 0.94;
  font-family: monospace;
  font-size: 11px;
  line-height: 1.5;
  user-select: none;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  border-bottom: 1px solid ${t('rule')};
  transition: border-color ${FADE};
  margin-bottom: 4px;
  padding-bottom: 2px;
`;

// running / paused / frozen / off. The only colour in the app, and only in dev.
const State = styled.span`
  color: ${props => (props.tone === 'ok' ? '#3fa45b' : props.tone === 'warn' ? '#c99a2e' : '#c15b5b')};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;

  span:first-child {
    color: ${t('muted')};
    transition: color ${FADE};
  }
`;

const Bar = styled.div`
  margin: 4px 0;
  height: 3px;
  background: ${t('rule')};
  transition: background-color ${FADE};

  div {
    height: 100%;
    width: ${props => Math.round(Math.min(1, props.fraction || 0) * 100)}%;
    background: ${t('muted')};
    transition: background-color ${FADE};
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 5px;

  button {
    flex: 1;
    padding: 2px 0;
    border: 1px solid ${t('rule')};
    background: transparent;
    color: ${t('fg')};
    transition: color ${FADE}, border-color ${FADE};
    font-family: monospace;
    font-size: 10px;
    cursor: pointer;
  }

  button:hover {
    border-color: ${t('fg')};
  }
`;

export { Bar, Buttons, Panel, Row, State, Title };
